<template>
    <section class="component">
        <section class="component__header">
            <span class="component__header__title">
                {{$t('com.file.camera-api-add-address-settings.app-camera')}}
            </span>
        </section>
        <section class="component__body">
            <section class="d-flex flex-column gap-3 px-3">
                <section class="d-flex flex-column gap-2">
                    <SearchLabelComponent :label="$t('com.file.set-camera-address-modal.add-camera-scheme')" />
                    <SearchSelectComponent v-model="currentScheme" :options="availableScheme" width="100%" />
                </section>
                <section class="d-flex flex-column gap-2">
                    <SearchLabelComponent :label="$t('com.file.set-camera-address-modal.add-camera-ip')" />
                    <InputComponent v-model="localSettings.cameraApiAddress" :isError="!isValidIp"  @blured="() => isValidIp = validateIp(localSettings.cameraApiAddress)"/>
                </section>
                <section class="d-flex flex-column gap-2">
                    <SearchLabelComponent :label="$t('com.file.set-camera-address-modal.add-camera-port')" />
                    <InputComponent v-model="localSettings.cameraApiAddressPort" type="number"/>
                </section>
                <section class="d-flex align-items-end flex-column">
                    <ButtonOutline @click="save" color="light" :disable="!isValidIp">{{$t('com.global.save')}}</ButtonOutline>
                </section>  
            </section>

        </section>

        <Transition>
            <CameraIpModal v-if="$store.state.modals.settings.cameraIpSettingsModalStatus" :ip="addressIp" @setIPAddress="setIPAddress" />
        </Transition>

    </section>
</template>
<script charset="utf-8">
    import SettingsService from "@/services/settings.service";
    import InputComponent from "../../../../BasicControls/InputComponent.vue";
    import SearchLabelComponent from "../../../../BasicControls/SearchLabelComponent.vue";
    import SearchSelectComponent from "../../../../BasicControls/SearchSelectComponent.vue";
    import CameraIpModal from "./Modals/SetCameraAddressModal.vue";
    import ButtonOutline from "../../../../BasicControls/Buttons/ButtonOutline.vue";
    import { encryptStorage } from '@/services/encrypt.service';
    import { validateIp } from "../../../../../helpers/utils";
    export default {
        name: "CameraAPiAddressSettings",
        components: {
            CameraIpModal,
            InputComponent,
            SearchLabelComponent,
            SearchSelectComponent,
            ButtonOutline
        },
        data() {
            return {
                localSettings: {...this.$store.state.settings.client},
                addressIp: this.$store.state.settings.client.cameraApiAddress,
                camModule: encryptStorage.getItem('modules').cam,
                availableScheme: [
                    {
                        value: 0,
                        label: 'http',
                    },
                    {
                        value: 10,
                        label: 'https',
                    },
                ],
                currentScheme: {},
                isValidIp: true 
            }
        },
        computed(){
        },
        mounted() {
            this.currentScheme = this.availableScheme.find(el => el.value === this.localSettings.cameraAddressScheme);
        },
        methods: {
            changeIp() {
                this.$store.commit('setCameraIpSettingsModalStatus', true);
            },
            async save() {
                try {
                    this.$store.commit("showLoader");
                    let request = {...this.localSettings};
                    request.cameraAddressScheme = this.currentScheme.value;

                    await SettingsService.updateClientSettings(request);
                    this.$store.commit("showSuccess");
                }
                catch (e) {
                    this.$store.commit("showError");
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'CameraAPiAddressSettings' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            validateIp
        },
    }
</script>
<style lang="scss" scoped>
    @use "@/assets/scss/user-profile-component.scss";

    .component {
        width: 400px;
        height: fit-content;
    }

    .avatar {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        padding: 15px 20px;
        align-items: center;
        justify-content: center;
        font-size: 24px;
    }

    .avatar-info {
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        &__item {
            display: flex;
            flex-direction: row;
            column-gap: 10px;
            padding: 10px;
            text-align: center;

            &__label {
                font-weight: 800;
            }
        }
    }
</style>